import React, { useState } from 'react';
import '../../_css/Faqs.css';

const faqData = [
    { question: 'What is PractAice?', answer: 'PractAice is a platform that allows you to practice AI-driven role plays for skills enhancement.' },
    { question: 'Can I delete my account?', answer: 'Yes, you can delete your account by visiting the Settings section and selecting "Delete My Data".' },
    { question: 'What competencies can I improve?', answer: 'You can enhance communication, leadership, negotiation, and more through role play scenarios.' },
    { question: 'How does the AI system work?', answer: 'The AI simulates realistic conversations responding based on context to give you a unique experience.' },
    { question: 'Can I customize my role play scenarios?', answer: 'Yes, you can customize scenarios in the dashboard.' },
    { question: 'Is there a way to track my progress?', answer: 'Yes, you can track progress via detailed analytics in the platform.' }
    // Add more...
];

const FrequentlyAsked = ({ searchTerm }) => {
    const [openIndex, setOpenIndex] = useState(null);

    const filteredFaqs = faqData.filter(faq =>
        faq.question.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const leftColumnFaqs = filteredFaqs.filter((_, idx) => idx % 2 === 0);
    const rightColumnFaqs = filteredFaqs.filter((_, idx) => idx % 2 !== 0);

    return (
        <div className="faq-wrapper">
            <h2 className="faq-title" style={
                {
                    font: "Clash Display",
                    fontWeight: "600",
                    lineHeight: "32px",
                    fontSize: "24px",
                    verticalAlign: "middle",
                    color: "#374151",
                    letterSpacing: "0%"

                }
            }>Frequently Asked Questions</h2>
            <div className="faq-grid-two-column">
                <div className="faq-column">
                    {leftColumnFaqs.map((faq, index) => {
                        const actualIndex = index * 2;
                        return (
                            <div key={actualIndex} className={`faq-card ${openIndex === actualIndex ? 'open' : ''}`} onClick={() => toggleFAQ(actualIndex)}>
                                <div className="faq-header">
                                    <span style={{
                                        fontWeight: "600",
                                        fontFamily: "Plus Jakarta Sans",
                                        fontSize: "16px",
                                        lineHeight: "24px",
                                        letterSpacing: "0%"
                                    }}>{faq.question}</span>
                                    <button className="icon-btn">
                                        {openIndex === actualIndex ? '×' : '+'}
                                    </button>
                                </div>
                                <div className="faq-content" style={{ maxHeight: openIndex === actualIndex ? '500px' : '0px' }}>
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="faq-column">
                    {rightColumnFaqs.map((faq, index) => {
                        const actualIndex = index * 2 + 1;
                        return (
                            <div key={actualIndex} className={`faq-card ${openIndex === actualIndex ? 'open' : ''}`} onClick={() => toggleFAQ(actualIndex)}>
                                <div className="faq-header">
                                    <span
                                        style={
                                            {
                                                fontWeight: "600",
                                                fontFamily: "Plus Jakarta Sans",
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                letterSpacing: "0%"
                                            }
                                        }>{faq.question}</span>
                                    <button className="icon-btn">
                                        {openIndex === actualIndex ? '×' : '+'}
                                    </button>
                                </div>
                                <div className="faq-content" style={{ maxHeight: openIndex === actualIndex ? '500px' : '0px' }}>
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default FrequentlyAsked;
